import React from 'react';

import { Box } from '@betterment/samba-react';

import { ExpandableDetailContext } from './ExpandableDetail';

export const ExpandableDetailContent: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isExpanded } = React.useContext(ExpandableDetailContext);
  return isExpanded ? (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.100', marginTop: 'space.100' }}>{children}</Box>
  ) : null;
};
